<template>
  <div class="w-full flex flex-col items-center justify-center md:max-w-[960px] text-center mt-[10rem]" :key="category">
    <div class="min-h-[10rem]">
      <h1 class="text-3xl font-bold text-center mb-8" style="color: var(--theme-text-heading);">
        {{ theCat.title }}
      </h1>
      <div class="px-4 md:max-w-2xl lg:max-w-3xl xl:max-w-6xl mx-auto text-left" v-if="theCat.description">
        <p class="text-sm italic" style="color: var(--theme-text-body);">{{theCat.description}}</p>
      </div>
      <div class="mt-10 flex flex-wrap justify-center gap-6" :style="cssVars">
        <component
            :is="cardComponent"
            v-for="(page, index) in pages"
            :key="index"
            v-motion
            :initial="{ opacity: 0, y: 30 }"
            :visible="{ opacity: 1, y: 0 }"
            :transition="{ duration: 1.5, ease: 'easeOut' }"
            :colors="colors"
            :variant="index % 2 === 0 ? 1 : 2"
            class="p-6 w-sm text-center hover:cursor-pointer hover:shadow-xl"
        >
          <router-link :to="back(page.link.url)">
            <div class=" rounded h-48" >
              <p class="mt-4 font-semibold" style="color: var(--theme-text-body);">
                {{ page.title }}
              </p>
              <h3 class="mt-4 font-thin line-clamp-2 " style="color: var(--theme-text-heading);">
                {{ page.description }}
              </h3>

            </div>
          </router-link>
        </component>
      </div>
    </div>
  </div>
</template>

<script setup>
import {usePageStore} from "@/stores/pageStore.js";
import {useColorStore} from "@/classes/useColorStore.js";
import {computed, onMounted, ref} from "vue";
import router from "@/router/index.js";
import {useThemedComponent} from "@/composables/useThemedComponent.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();
const navStore = usePageStore();

const cardComponent = useThemedComponent("card");

const pageStore = usePageStore();
const pageData = computed(() => pageStore.pageData); // ✅ Access injected data

const props = defineProps({
  category: String,
  colors: Object
})


// A heading with no pages left isn't in the live menu: show it empty rather
// than throwing (a direct or old link to /explore-categories/<slug>).
const theCat = (navStore.navData || []).find(cat => cat.slug === props.category) || {title: 'Nothing here yet', description: '', links: []}
const pages = ref((theCat.links || []).map(link => ({title: link.name, description: link.description, image:{url: ''}, link: {url:link.link}})))

onMounted(async () => {
  if (import.meta.env.SSR) return; // ✅ Prevent running on the server
})



// Compute CSS variables for dynamic background and card colors
const cssVars = computed(() => ({
  "--bg-light-variant-1": "#ffffff",
  "--bg-light-variant-2": props.colors.lightest,
  "--bg-dark-variant-1": props.colors.dark,
  "--bg-dark-variant-2": props.colors.darkest,
  "--card-light": props.colors.white,
  "--card-light-alt": props.colors.whitest,
  "--card-dark": props.colors.dark,
  "--card-dark-alt": props.colors.darkest,
  "--border-color-light": props.colors.accent,
  "--border-color-dark": props.colors.accentDark
}));




</script>

<style scoped>
/* Smooth background transitions */
.transition-colors {
  transition: background-color 0.3s ease-in-out;
}
</style>